import { gql } from "generated-graphql";

export const CERS_FACILITY_MATCHES = gql(`
  query CersFacilityMatches($filter: CersFacilityMatchFilter, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    cersFacilityMatches(filter: $filter, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        cersId
        name
        siteAddress
        city
        zipCode
        county
        epaId
        matchStatus
        cupa {
          displayName
        }
        business {
          cersBusinessId
          cersName
        }
        encampFacility {
          id
          name
          tenantId
        }
        suggestions {
          id
          source
          score
          confidence
          candidateFacility {
            id
            name
            streetAddress1
            city
            state
            zip
            county
            epaIdStatuses {
              epaId
              isPrimaryForFacility
              isInactive
            }
          }
        }
      }
    }
  }
`);

export const CERS_FACILITY_ADDRESS_MATCHES = gql(`
  query CersFacilityAddressMatches($cersFacilityId: ID!) {
    cersFacilityAddressMatches(cersFacilityId: $cersFacilityId) {
      id
      name
      streetAddress1
      city
      state
      zip
      county
      epaIdStatuses {
        epaId
        isPrimaryForFacility
        isInactive
      }
    }
  }
`);

// Dialog-local facility search: mirrors the grid's Encamp cell format
// (name / address / county). Intentionally does NOT select epaIdStatuses — it's
// a non-null RCRA field and resolving it across arbitrary multi-tenant search
// results nulls the whole result set when any row errors, which broke search.
export const CERS_FACILITY_SEARCH = gql(`
  query CersFacilitySearch($search: String, $page: Int, $pageSize: Int) {
    facilities(search: $search, page: $page, pageSize: $pageSize) {
      items {
        id
        name
        streetAddress1
        city
        state
        zip
        county
      }
      count
    }
  }
`);

export const CERS_FACILITY_MATCH_STATS = gql(`
  query CersFacilityMatchStats {
    cersFacilityMatchStats {
      unmatched
      suggested
      matched
    }
  }
`);

export const LINK_CERS_FACILITY = gql(`
  mutation LinkCersFacility($cersFacilityId: ID!, $encampFacilityId: ID!) {
    linkCersFacility(cersFacilityId: $cersFacilityId, encampFacilityId: $encampFacilityId) {
      cersId
      matchStatus
      encampFacility {
        id
        name
      }
    }
  }
`);
